import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import ExchangeListingHero from "./ExchangeListingHero";
import Comprehensive from "./Comprehensive";
import TopCryptoE from "./TopCryptoE";

function ExchangeListing() {
  return (
    <div>
      <Header />
      <ExchangeListingHero />
      <Comprehensive />
      <TopCryptoE />
      <Footer />
    </div>
  );
}

export default ExchangeListing;
